import React from 'react';

const Card = (props) => {
    return (
        <div className={`${props.className}`}>
            {props.label && (
                <div className='section-label mb-3 px-1'>{props.label}</div>
            )}
            <div className='text-white shadow-xl rounded-2xl w-full border' style={{background: 'var(--card-bg)', borderColor: 'var(--card-border)', boxShadow: 'var(--card-shadow)'}}>
                <div className="container mx-auto">
                    {props.children}
                </div>
            </div>
        </div>
    )
}

export default Card;
